/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileLarge } from "./_background/background-file-large.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileShortcutLarge = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--large",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "large" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 160,
      height: 160,
      className: cls,
      "data-testid": "FileShortcutLarge",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileLarge, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M34.048 34A123.12 123.12 0 0 0 34 37.5c0 1.247.017 2.409.048 3.5h6.9c.031-1.091.048-2.253.048-3.5 0-1.247-.017-2.409-.048-3.5h-6.9Zm6.764 10h-6.624c.406 6.1 1.484 9 3.312 9 1.828 0 2.906-2.9 3.312-9ZM44 37.5c0 1.221-.016 2.381-.045 3.5h8.823a27.701 27.701 0 0 0 0-7h-8.823c.03 1.119.045 2.279.045 3.5Zm-.173-6.5h8.307c-1.446-4.733-4.738-7.567-9.927-8.572A25.986 25.986 0 0 1 43.827 31Zm-12.654 0a25.987 25.987 0 0 1 1.621-8.572c-5.189 1-8.481 3.839-9.927 8.572h8.306Zm0 13h-8.307c1.446 4.733 4.738 7.567 9.927 8.572A25.986 25.986 0 0 1 31.173 44Zm12.654 0a25.989 25.989 0 0 1-1.621 8.572c5.189-1 8.481-3.839 9.927-8.572h-8.306Zm-9.639-13h6.624c-.406-6.1-1.484-9-3.312-9-1.828 0-2.906 2.9-3.312 9Zm-11.966 3a27.701 27.701 0 0 0 0 7h8.823a134.688 134.688 0 0 1 0-7h-8.823Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M40.812 31c-.406-6.1-1.484-9-3.312-9-1.828 0-2.906 2.9-3.312 9h.075c.455-5.417 1.512-8 3.237-8s2.782 2.583 3.237 8h.075Zm-8.391-7.496c.117-.361.24-.72.373-1.076-5.189 1-8.481 3.839-9.927 8.572h.344c1.548-4.027 4.606-6.513 9.21-7.496ZM51.79 31h.344c-1.446-4.733-4.738-7.567-9.927-8.572.132.356.257.715.373 1.076 4.604.988 7.662 3.47 9.21 7.496Zm-17.742 3a123.12 123.12 0 0 0-.047 4c.004-1.06.02-2.056.047-3h6.9c.027.944.043 1.94.047 3l.001-.5c0-1.247-.017-2.409-.048-3.5h-6.9Zm.215 11h6.474c.027-.323.052-.657.075-1h-6.624c.023.343.048.677.075 1ZM44 38a135.22 135.22 0 0 1-.045 3h.022A135.348 135.348 0 0 0 44 38Zm8.996 0a27.688 27.688 0 0 0-.218-4h-8.823c.009.33.016.663.022 1h8.801c.127.996.2 1.998.218 3Zm-21.823 6h-8.307c.105.343.22.677.344 1h7.963a25.984 25.984 0 0 0 1.247 7.496c.123.026.248.052.373.076A25.986 25.986 0 0 1 31.173 44Zm11.033 8.572A25.981 25.981 0 0 0 43.826 44h8.307c-.105.343-.22.677-.344 1h-7.962a25.98 25.98 0 0 1-1.248 7.496c-.123.027-.248.052-.373.076ZM22.005 38a27.703 27.703 0 0 1 .217-4h8.823c-.009.33-.016.663-.022 1h-8.8c-.128.996-.2 1.998-.218 3Zm9.018 3h.022c-.025-.965-.04-1.96-.044-3a137.922 137.922 0 0 0 .022 3Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m15.5 60.5.173 8.827-.93.018-.142-7.289-7.773 7.773-.657-.657 7.772-7.773-7.288-.143.018-.93 8.827.174Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m15.499 60.499-8.827-.174-.018.93h.007l.011-.547 8.827.173.165 8.445h.008l-.173-8.827Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m6.361 69.361 7.581-7.581-.375-.007L6.17 69.17l.191.191Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FileShortcutLarge
};
